/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Auth_Error_TitleInputs */

const en_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorization Error`)
};

const fr_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur d'autorisation`)
};

const de_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisierungsfehler`)
};

const it_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore di autorizzazione`)
};

const ru_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка авторизации`)
};

const es_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de autorización`)
};

const zh_cn2_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权错误`)
};

const ja_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証エラー`)
};

const hi_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राधिकरण त्रुटि`)
};

const pt_pt2_creator_auth_error_title = /** @type {(inputs: Creator_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro de autorização`)
};

/**
* | output |
* | --- |
* | "Authorization Error" |
*
* @param {Creator_Auth_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_auth_error_title = /** @type {((inputs?: Creator_Auth_Error_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Auth_Error_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_auth_error_title(inputs)
	if (locale === "de") return de_creator_auth_error_title(inputs)
	if (locale === "it") return it_creator_auth_error_title(inputs)
	if (locale === "ru") return ru_creator_auth_error_title(inputs)
	if (locale === "es") return es_creator_auth_error_title(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_auth_error_title(inputs)
	if (locale === "ja") return ja_creator_auth_error_title(inputs)
	if (locale === "hi") return hi_creator_auth_error_title(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_auth_error_title(inputs)
	return en_creator_auth_error_title(inputs)
});